<template>
    <div>
        <div class="policy">
            <a href="#" v-if="canEdit" class="change link collapsed" data-toggle="collapse" data-target="#searchcollapse" aria-expanded="false" aria-controls="#searchcollapse" @click="scrollTo('#searchcollapse')">Змінити</a>
            <div class="title d-lg-block">Параметри калькуляції</div>
            <hr class="d-none d-lg-block">
            <div class="specific d-lg-block">
                <b>Об'єкт страхування</b>
                <p>{{policyInfo.homeType.name}}</p>
            </div>
            <div class="specific d-lg-block">
                <b>Страхова сума</b>
                <p>{{policyInfo.insuranceAmount.name}} грн</p>
            </div>
            <div class="specific d-lg-block">
                <b>Період страхування</b>
                <p>{{policyInfo.insurancePeriod.name}}</p>
            </div>
            <div class="specific d-lg-block">
                <b>Початок дії</b>
                <p>{{policyInfo.startDate}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['canEdit'],
    data() {
        return {

        };
    },
    computed: {
        policyInfo() {
            return this.$store.state.HomeInsuranceCompanyStore.requestData;
        }
    },
    methods: {
        scrollTo(item){
            let el = item;
            $('html,body').animate({
                scrollTop: $(el).offset().top + 150
            }, 1000);
        },
    },
}
</script>
<style scoped>
@media (max-width: 1199px) {
    .policy {
        .change {
            display: block;
            position: initial;
        }
    }
}
</style>
